import React, { type CSSProperties } from 'react';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material';

const UploadFileContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
});

const TitleContainer = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
});

const StyledInput = styled('input')(({ disabled }) => ({
    display: 'flex',
    width: '100%',
    fontSize: '0.75rem',
    margin: 0,
    zIndex: 10,
    borderRadius: '3px',
    color: disabled ? '#999999' : 'black',

    '&::file-selector-button': {
        margin: 0,
        backgroundColor: '#f7f6ff',
        border: 'none',
        textTransform: 'uppercase',
        marginRight: '10px',
        padding: '1px 11px 2px 11px',
        color: disabled ? '#999999' : 'black',
    },

    '&::file-selector-button:hover': {
        cursor: !disabled ? 'pointer' : undefined,
        backgroundColor: !disabled ? 'white' : undefined,
    },

    '&::-webkit-file-upload-button': {
        margin: 0,
        backgroundColor: '#f7f6ff',
        border: 'none',
        textTransform: 'uppercase',
        marginRight: '10px',
        padding: '1px 11px 2px 11px',
        color: disabled ? '#999999' : 'black',
    },

    '&::-webkit-file-upload-button:hover': {
        cursor: !disabled ? 'pointer' : undefined,
        backgroundColor: !disabled ? 'white' : undefined,
    },

    '&:focus': {
        outline: 0,
    },

    '&:hover': {
        cursor: disabled ? 'not-allowed' : 'pointer',
    },
}));

type FileUploaderProps = {
    label: string;
    subLabel?: string;
    accept: string;
    multiple?: boolean;
    error?: string;
    containerStyle?: CSSProperties;
    inputStyle?: CSSProperties;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export default ({
    label,
    subLabel,
    accept,
    multiple,
    error,
    containerStyle,
    inputStyle,
    onChange,
}: FileUploaderProps) => {
    const theme = useTheme();
    return (
        <UploadFileContainer style={containerStyle}>
            <TitleContainer>
                <Typography variant="h4">{label}</Typography>
                {subLabel && (
                    <Typography variant="h5" color={'#999999'}>
                        {subLabel}
                    </Typography>
                )}
            </TitleContainer>
            <Button
                variant="outlined"
                component="label"
                style={inputStyle}
                sx={{
                    color: '#999999',
                    borderColor: error ? theme.palette.error.main : '#999999',
                    justifyContent: 'flex-start',
                    paddingLeft: '10px',
                    ':hover': {
                        borderColor: '#999999',
                        backgroundColor: 'white',
                    },
                }}
            >
                <StyledInput
                    type="file"
                    accept={accept}
                    multiple={multiple}
                    onChange={onChange}
                />
            </Button>
            {error && (
                <Typography variant="h5" color={theme.palette.error.main}>
                    {error}
                </Typography>
            )}
        </UploadFileContainer>
    );
};
